export * from './navigation-menu.component';
export * from './navigation-menu.module';
export * from './navigation-menu-container.interface';



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/generic/navigation-menu/index.ts